export const DEFAULT_CREATE_AXES_PARAMS = {
  fact_work: null,
  plan_work: null,
  plan_group: null,
  fact_group: null,
};
